import { WizardName } from '../../../types';
import { DataCollectionValues } from '../../../types/DataCollectionValues';

export function saveFormDataLocalStorage(wizardName: WizardName, values: any): void {
    localStorage.setItem(wizardName, JSON.stringify(values));
}

export function loadFormDataLocalStorage(wizardName: string): DataCollectionValues | null {
    const storedProgress = localStorage.getItem(wizardName);

    if (!storedProgress) {
        return null;
    }

    return JSON.parse(storedProgress);
}

export function clearFormDataLocalStorage(wizardName: string): void {
    localStorage.removeItem(wizardName);
}
